<div class="its-course-catalogue-coursecard__properties">
    {#if subject}
        <div class="its-course-catalogue-coursecard__property">
            <span class="its-course-catalogue-property__label">{lang.main('Course_catalogue_subject')}:</span>
            <span class="its-course-catalogue-property__value">{subject}</span>
        </div>
    {/if}
    {#if educationalLevel}
        <div class="its-course-catalogue-coursecard__property">
            <span class="its-course-catalogue-property__label">{lang.main('Course_catalogue_age_group')}:</span>
            <span class="its-course-catalogue-property__value">{educationalLevel}</span>
        </div>
    {/if}
    {#if targetRole}
        <div class="its-course-catalogue-coursecard__property">
            <span class="its-course-catalogue-property__label">{lang.main('Course_catalogue_Target_role')}:</span>
            <span class="its-course-catalogue-property__value">{targetRole}</span>
        </div>
    {/if}
</div>

<script>
    import { lang } from "@its-ui/mono/lang/provider";

    export let targetRole = '';
    export let subject = '';
    export let educationalLevel = '';
</script>
